module.exports = __webpack_public_path__ + "static/media/a5lg.b1465b62.png";